export default "__VITE_ASSET__CY43XGpW__"